'use client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { customerJWT } from '@repo/customer-api';
import { OfflineBanner, ReduxToast, theme } from '@repo/ui';
import { getClientCookie, parseJwt, SendNavigatorData, splitFullName } from '@repo/utils';
import { useEffect, useState } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { CustomerModal } from '../components/modal';
import { hideToast } from './navigationSlice';
import { makeStore, RootState } from './store';
import { pushUserdata } from './userdataSlice';

const LoadUserData = () => {
  const dispatch = useDispatch();
  const token = getClientCookie('token-customer');
  useEffect(() => {
    // Parsed inside the effect: a fresh object per render would re-run it on every render
    const decodedToken = parseJwt(token || '') as customerJWT;
    if (decodedToken) {
      const { firstName, fullName } = splitFullName(decodedToken.fullName);
      dispatch(
        pushUserdata({
          username: fullName,
          firstName,
          userId: `${decodedToken.userId}`,
        }),
      );
    }
  }, [dispatch, token]);
  return <></>;
};

export function Providers({ children }: { children: React.ReactNode }) {
  const [store] = useState(makeStore);
  useEffect(() => {
    SendNavigatorData({
      app: 'customer',
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <OfflineBanner />
      <Provider store={store}>
        <LoadUserData />
        <CustomerModal />
        <ReduxToast selectToast={(state: RootState) => state.navigationdata.toastData} hideToast={hideToast} />
        {children}
      </Provider>
    </ThemeProvider>
  );
}
